import { render, staticRenderFns } from "./finals.vue?vue&type=template&id=1a4655d5&"
import script from "./finals.vue?vue&type=script&lang=js&"
export * from "./finals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports